import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useTranslation} from '#imports';
import {pushVJoySnackbar} from '@maltjoy/core-vue';
import {Configuration} from '@api';
import {ClientInfosApi, type ClientInfosResource} from '~/openapi';
import {readonlyState} from '#build/@malt-nuxt-utils-module';

export const useClientDetailsStore = defineStore('repatriation-client-details', () => {
    const configuration = new Configuration({basePath: ''});
    const clientInfoApi = new ClientInfosApi(configuration);
    const clientInfos = ref<ClientInfosResource | undefined>();

    const {t} = useTranslation();

    async function getClientInfos() {
        try {
            clientInfos.value = await clientInfoApi.getClientInfos();
        } catch {
            pushVJoySnackbar({props: {message: t('generic.technical.error'), level: 'error'}});
        }
    }

    return {clientInfos: readonlyState(clientInfos), getClientInfos};
});
